import { useEffect, useRef, useState } from 'react';

import { Button } from '@mantine/core';

interface BeforeInstallPromptEvent extends Event {
	readonly platforms: Array<string>;
	readonly userChoice: Promise<{
		outcome: 'accepted' | 'dismissed';
		platform: string;
	}>;
	prompt(): Promise<void>;
}

const UseInstallPwa = () => {
	const [installPrompt, setInstallPrompt] = useState<BeforeInstallPromptEvent | null>(null);
	const installButton = useRef<HTMLButtonElement>(null);
	const [isInstallButtonHidden, setIsInstallButtonHidden] = useState(true);

	const handleShowInstallButton = (event: Event) => {
		event.preventDefault();
		setInstallPrompt(event as BeforeInstallPromptEvent);
		setIsInstallButtonHidden(false);
	};

	const handleInstallPWA = async () => {
		if (!installPrompt) return;
		await installPrompt.prompt();

		setInstallPrompt(null);
	};

	useEffect(() => {
		window.addEventListener('beforeinstallprompt', handleShowInstallButton);

		return () => window.removeEventListener('beforeinstallprompt', handleShowInstallButton);
	}, []);

	return (
		<Button
			ref={installButton}
			size={'md'}
			variant={'light'}
			onClick={handleInstallPWA}
			display={isInstallButtonHidden ? 'none' : 'block'}
		>
			Установить приложение
		</Button>
	);
};

export default UseInstallPwa;
